import { loc } from 'okta';
export default {
  title() {
    return loc('oie.email.mfa.title', 'login');
  }
};
